export default "__VITE_ASSET__f30942c0__"